/**
 * Frontend JavaScript for Search Block
 */

(function() {
	'use strict';

	let searchTimeout;
	let selectedProductIndex = 0;
	let allProducts = [];
	let currentOffset = 0;
	let currentQuery = '';
	let hasMoreResults = false;

	// Elements
	const searchToggle = document.getElementById('search-toggle');
	const searchSidebar = document.getElementById('search-sidebar');
	const searchClose = document.getElementById('search-close');
	const searchOverlay = document.getElementById('search-sidebar-overlay');
	const searchInput = document.getElementById('product-search-input');
	const resultsLeft = document.getElementById('search-results-left');
	const resultsRight = document.getElementById('search-results-right');
	const noResults = document.getElementById('search-no-results');
	const loadingIndicator = document.getElementById('search-loading');

	// Set up event delegation for product items (once)
	function setupProductItemDelegation() {
		if (!resultsLeft) return;
		
		// Use event delegation on the results container
		resultsLeft.addEventListener('mouseenter', function(e) {
			const item = e.target.closest('.product-item');
			if (item) {
				const index = parseInt(item.getAttribute('data-index'));
				selectedProductIndex = index;
				
				// Update selected state
				const allItems = resultsLeft.querySelectorAll('.product-item');
				allItems.forEach(i => i.classList.remove('selected'));
				item.classList.add('selected');
				
				// Update preview
				if (allProducts[index]) {
					displayPreview(allProducts[index]);
				}
			}
		}, true);

		resultsLeft.addEventListener('click', function(e) {
			const item = e.target.closest('.product-item');
			if (item) {
				e.preventDefault();
				const productId = item.getAttribute('data-product-id');
				const index = parseInt(item.getAttribute('data-index'));
				if (productId && allProducts[index]) {
					window.location.href = allProducts[index].url;
				}
			}
		});
	}

	// Set up delegation once
	setupProductItemDelegation();

	// Open sidebar
	function openSearch() {
		if (!searchSidebar || !searchToggle) return;
		
		searchSidebar.setAttribute('aria-hidden', 'false');
		if (searchOverlay) searchOverlay.setAttribute('aria-hidden', 'false');
		searchToggle.setAttribute('aria-expanded', 'true');
		document.body.style.overflow = 'hidden';
		
		// Focus search input
		setTimeout(() => {
			if (searchInput) {
				searchInput.focus();
			}
		}, 100);
	}

	// Close sidebar
	function closeSearch() {
		if (!searchSidebar || !searchToggle) return;
		
		searchSidebar.setAttribute('aria-hidden', 'true');
		if (searchOverlay) searchOverlay.setAttribute('aria-hidden', 'true');
		searchToggle.setAttribute('aria-expanded', 'false');
		document.body.style.overflow = '';
		
		// Clear results
		if (resultsLeft) resultsLeft.innerHTML = '';
		if (resultsRight) resultsRight.innerHTML = '';
		if (searchInput) searchInput.value = '';
		selectedProductIndex = 0;
		allProducts = [];
		currentOffset = 0;
		currentQuery = '';
		hasMoreResults = false;
	}

	// Toggle sidebar
	if (searchToggle) {
		searchToggle.addEventListener('click', openSearch);
	}

	if (searchClose) {
		searchClose.addEventListener('click', closeSearch);
	}

	if (searchOverlay) {
		searchOverlay.addEventListener('click', closeSearch);
	}

	// Close on Escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && searchSidebar && searchSidebar.getAttribute('aria-hidden') === 'false') {
			closeSearch();
		}
	});

	// Search functionality
	function performSearch(query, append = false) {
		if (!query || query.length < 2) {
			if (!append) {
				if (resultsLeft) resultsLeft.innerHTML = '';
				if (resultsRight) resultsRight.innerHTML = '';
				if (noResults) noResults.style.display = 'none';
				allProducts = [];
				currentOffset = 0;
				currentQuery = '';
				hasMoreResults = false;
			}
			return;
		}

		// Reset if new search
		if (!append) {
			currentQuery = query;
			currentOffset = 0;
			allProducts = [];
			selectedProductIndex = 0;
		}

		// Show loading
		if (loadingIndicator) loadingIndicator.style.display = 'block';
		if (noResults) noResults.style.display = 'none';

		// Clear previous timeout
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		// Debounce search (only for new searches, not load more)
		if (!append) {
			searchTimeout = setTimeout(() => {
				fetchSearchResults(query, append);
			}, 300);
		} else {
			fetchSearchResults(query, append);
		}
	}

	// Fetch search results from server
	function fetchSearchResults(query, append = false) {
		const formData = new FormData();
		formData.append('action', 'dougie_product_search');
		formData.append('query', query);
		formData.append('offset', currentOffset);
		formData.append('nonce', dougieSearch.nonce);

		fetch(dougieSearch.ajaxUrl, {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (loadingIndicator) loadingIndicator.style.display = 'none';
			
			if (data.success && data.data.products && data.data.products.length > 0) {
				// Append or replace products
				if (append) {
					allProducts = [...allProducts, ...data.data.products];
				} else {
					allProducts = data.data.products;
				}
				
				hasMoreResults = data.data.has_more || false;
				currentOffset = allProducts.length;
				
				// Pass the newly fetched products for display
				displayResults(data.data.products, append);
				if (noResults) noResults.style.display = 'none';
			} else {
				if (!append) {
					if (resultsLeft) resultsLeft.innerHTML = '';
					if (resultsRight) resultsRight.innerHTML = '';
					if (noResults) noResults.style.display = 'block';
					allProducts = [];
					hasMoreResults = false;
				}
			}
		})
		.catch(error => {
			console.error('Search error:', error);
			if (loadingIndicator) loadingIndicator.style.display = 'none';
			if (!append && noResults) noResults.style.display = 'block';
		});
	}

	// Load more results
	function loadMoreResults() {
		if (currentQuery && hasMoreResults) {
			performSearch(currentQuery, true);
		}
	}

	// Display search results
	function displayResults(products, append = false) {
		if (!resultsLeft || !resultsRight) return;

		if (!append) {
			selectedProductIndex = 0;
		}

		// Build left column (product list)
		let leftHTML = '';
		if (!append) {
			leftHTML = '<ul class="product-list">';
		}
		
		const startIndex = append ? allProducts.length - products.length : 0;
		products.forEach((product, index) => {
			const globalIndex = startIndex + index;
			const isSelected = (!append && index === 0) || (append && globalIndex === selectedProductIndex) ? 'selected' : '';
			leftHTML += `
				<li class="product-item ${isSelected}" data-index="${globalIndex}" data-product-id="${product.id}">
					${product.image ? `<div class="product-item-image"><img src="${product.image}" alt="${product.title}" /></div>` : ''}
					<div class="product-item-details">
						<h3 class="product-item-title">${product.title}</h3>
						<div class="product-item-price">${product.price}</div>
					</div>
				</li>
			`;
		});
		
		if (!append) {
			leftHTML += '</ul>';
			resultsLeft.innerHTML = leftHTML;
		} else {
			// Remove existing load more button before appending
			const existingLoadMore = resultsLeft.querySelector('.load-more-button');
			if (existingLoadMore) {
				existingLoadMore.remove();
			}
			
			const productList = resultsLeft.querySelector('.product-list');
			if (productList) {
				// Create a temporary container to parse HTML
				const temp = document.createElement('div');
				temp.innerHTML = leftHTML;
				const newItems = temp.querySelectorAll('li');
				
				// Append each item individually
				newItems.forEach(item => {
					productList.appendChild(item);
				});
			}
		}

		// Display first product preview (only on new search)
		if (!append && products.length > 0) {
			displayPreview(products[0]);
		}

		// Event delegation is already set up, so new items will work automatically

		// Show/hide Load More button
		updateLoadMoreButton();
	}

	// Update Load More button
	function updateLoadMoreButton() {
		let loadMoreBtn = resultsLeft.querySelector('.load-more-button');
		
		if (hasMoreResults) {
			if (!loadMoreBtn) {
				loadMoreBtn = document.createElement('button');
				loadMoreBtn.className = 'load-more-button';
				loadMoreBtn.textContent = 'Load More';
				loadMoreBtn.addEventListener('click', loadMoreResults);
				
				// Append to results container, not the list
				if (resultsLeft) {
					resultsLeft.appendChild(loadMoreBtn);
				}
			}
			loadMoreBtn.style.display = 'block';
		} else {
			if (loadMoreBtn) {
				loadMoreBtn.style.display = 'none';
			}
		}
	}

	// Display product preview
	function displayPreview(product) {
		if (!resultsRight || !product) return;

		const addToCartUrl = product.add_to_cart_url || product.url;
		const isPurchasable = product.is_purchasable && product.type !== 'variable' && product.type !== 'grouped';

		resultsRight.innerHTML = `
			<div class="product-preview">
				${product.image ? `
					<div class="product-preview-image">
						<img src="${product.image}" alt="${product.title}" />
					</div>
				` : ''}
				<div class="product-preview-details">
					<h2 class="product-preview-title">
						<a href="${product.url}">${product.title}</a>
					</h2>
					<div class="product-preview-price">${product.price}</div>
					${product.description ? `<div class="product-preview-description">${product.description}</div>` : ''}
					${isPurchasable ? `
						<div class="product-preview-actions">
							<button 
								type="button" 
								class="button add-to-cart-button ajax-add-to-cart" 
								data-product-id="${product.id}"
								data-product-type="${product.type}"
							>
								${product.add_to_cart_text || 'Add to Cart'}
							</button>
						</div>
					` : `
						<div class="product-preview-actions">
							<a href="${product.url}" class="button view-product-button">View Product</a>
						</div>
					`}
				</div>
			</div>
		`;

		// Attach AJAX add to cart handler
		if (isPurchasable) {
			const addToCartBtn = resultsRight.querySelector('.ajax-add-to-cart');
			if (addToCartBtn) {
				addToCartBtn.addEventListener('click', function(e) {
					e.preventDefault();
					handleAjaxAddToCart(product.id, this);
				});
			}
		}
	}

	// Handle AJAX add to cart
	function handleAjaxAddToCart(productId, button) {
		if (!productId) return;

		// Disable button and show loading state
		const originalText = button.textContent;
		button.disabled = true;
		button.textContent = 'Adding...';
		button.classList.add('loading');

		// Get WooCommerce AJAX URL
		let wcAjaxUrl;
		if (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.wc_ajax_url) {
			wcAjaxUrl = wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart');
		} else {
			// Fallback: construct WC AJAX URL
			const baseUrl = dougieSearch.ajaxUrl.substring(0, dougieSearch.ajaxUrl.indexOf('/wp-admin'));
			wcAjaxUrl = baseUrl + '/?wc-ajax=add_to_cart';
		}

		// Prepare form data
		const formData = new FormData();
		formData.append('product_id', productId);
		formData.append('quantity', 1);

		// Make AJAX request
		fetch(wcAjaxUrl, {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			// Re-enable button
			button.disabled = false;
			button.classList.remove('loading');

			if (data.error && data.product_url) {
				// Error occurred, redirect to product page
				window.location.href = data.product_url;
				return;
			}

			// Success - update button text and trigger cart update
			button.textContent = 'Added!';
			button.classList.add('added');

			// Update header cart
			updateHeaderCart();

			// Trigger WooCommerce cart fragments update if available
			if (typeof jQuery !== 'undefined' && data.fragments) {
				jQuery(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash, jQuery(button)]);
			}

			// Reset button after 2 seconds
			setTimeout(() => {
				button.textContent = originalText;
				button.classList.remove('added');
			}, 2000);
		})
		.catch(error => {
			console.error('Add to cart error:', error);
			button.disabled = false;
			button.textContent = originalText;
			button.classList.remove('loading');
			
			// Fallback to product page if AJAX fails
			const productUrl = allProducts.find(p => p.id === productId)?.url;
			if (productUrl) {
				window.location.href = productUrl;
			}
		});
	}

	// Update header cart after adding product
	function updateHeaderCart() {
		const formData = new FormData();
		formData.append('action', 'dougie_get_cart');
		formData.append('nonce', dougieSearch.nonce);

		fetch(dougieSearch.ajaxUrl, {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Update cart count
				const cartCount = document.getElementById('header-cart-count');
				if (cartCount) {
					if (data.data.cart_count > 0) {
						cartCount.textContent = data.data.cart_count;
						cartCount.style.display = 'flex';
					} else {
						cartCount.style.display = 'none';
					}
				}

				// Update cart dropdown content
				const cartContent = document.getElementById('header-cart-content');
				if (cartContent && data.data.cart_html) {
					cartContent.innerHTML = data.data.cart_html;
				}
			}
		})
		.catch(error => {
			console.error('Cart update error:', error);
		});
	}

	// Search input handler
	if (searchInput) {
		searchInput.addEventListener('input', function(e) {
			const query = e.target.value.trim();
			performSearch(query);
		});

		searchInput.addEventListener('keydown', function(e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				const query = e.target.value.trim();
				if (query.length >= 2) {
					performSearch(query);
				}
			}
		});
	}

})();

